import functions from "./functions.js";

// Upit da ograničimo prijave sa godištem dece - djeca starija od AGE_LIMIT_YEARS
// na dan polaska idu na "Request" umesto direktne rezervacije. Relative to the
// trip's own dateFrom (not a fixed calendar date), so it keeps working as
// trips move.
const AGE_LIMIT_YEARS = 14;

function isOverAgeLimit(birthDateObj, dateFrom) {
    if (! birthDateObj || ! dateFrom) {
        return false;
    }

    const [year, month, day] = dateFrom.split('-').map(Number);
    const cutoff = new Date(year - AGE_LIMIT_YEARS, (month || 1) - 1, day || 1);

    return birthDateObj <= cutoff;
}

$(() => {
    const $form = $('.booking-form');
    const form = $form[0];

    if (! form) {
        return;
    }

    const booking = {
        $form: null,
        form: null,
        $payment: null,
        $calculation: null,
        calc: [],
        persons: null,
        totalAmount: null,
        status: null,

        init() {
            booking.$form = $(".booking-form");
            booking.form = booking.$form.first();

            if (! booking.$form.length) {
                return;
            }

            // BOOKING PAYMENT TYPE CHECKBOX
            if($('[name="paymentType"]')[0]) {
                checkPaymentType();
                $('[name="paymentType"]').on('change', e => {
                    checkPaymentType();
                });

                function checkPaymentType() {
                    $('[name="paymentType"]').each((index, item) => {
                        const $item = $(item);
                        const id = $item.attr('id');
                        $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                    });
                }
            }

            booking.$calculation = $(".table-calculation");
            booking.$payment = $(".payment-details");
            booking.params = {};

            booking.$calculation.find("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            booking.$calculation.find('input[type="checkbox"]').change(function (e) {
                let $row = $(this).closest('.calc-item');
                let $quantity = $row.find('[name=quantity]');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });

            booking.$calculation.find('input[type="checkbox"]').each((index, item) => {
                item.checked && $(item).first().trigger('change');
            });

            booking.$calculation.find('select.quantity').change(function (e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();

            booking.$form.on('submit', e => {
                //e.stopPropagation();
                if (! booking.validate()) {
                    e.preventDefault();
                    return;
                }
                $('button[type="submit"]').attr('disabled', 'disabled');
                booking.submit();
            });

            // clear the email-mismatch error as soon as either field is edited
            booking.$form.on('input', '[name="email"], [name="emailConfirm"]', () => {
                booking.$form.find('.email-confirm-error').addClass('d-none');
            });

        },
        validate() {
            let email = (booking.$form.find('[name="email"]').val() || '').trim();
            let confirm = (booking.$form.find('[name="emailConfirm"]').val() || '').trim();

            if (email !== confirm) {
                booking.$form.find('.email-confirm-error').removeClass('d-none');
                booking.$form.find('[name="emailConfirm"]')[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
                return false;
            }

            return true;
        },
        submit() {

            let formData = functions.getFormData(booking.$form);
            let guests = [];
            let shirts = [];
            let note = '';
            let needsRequest = false;
            // country calling code (phoneCountryCode select) + the number -
            // same for every guest, so it's computed once here.
            let phone = ((formData.phoneCountryCode || '') + ' ' + (formData.phone || '')).trim();

            $.each(booking.calc, function(key, item) {
                if ( ! item.inCalc) {
                    delete booking.calc[key];
                }
                else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    guests = [];
                    shirts = [];

                    $('.guest-item').each((i, elem) => {
                        const $elem = $(elem);
                        const index = +$elem.data('index');
                        let guestData = [];

                        $.map(formData, (value, name) => {
                            if(name.endsWith(index)) {
                                guestData[name] = value;
                            }
                        });

                        let firstName = guestData['guestFirstName' + index ];
                        let lastName = guestData['guestLastName' + index ];
                        let birthDateDay = guestData['birthDateDay' + index ] ? guestData['birthDateDay' + index ] : null;
                        let birthDateMonth = guestData['birthDateMonth' + index ] ? guestData['birthDateMonth' + index ] : null;
                        let birthDateYear = guestData['birthDateYear' + index ] ? guestData['birthDateYear' + index ] : null;
                        let gender = guestData['gender' + index ] ? guestData['gender' + index ] : null;
                        let teacherName = guestData['teacherName' + index ] ? guestData['teacherName' + index ] : null;
                        let schoolName = guestData['schoolName' + index ] ? guestData['schoolName' + index ] : null;
                        let city = guestData['city' + index ] ? guestData['city' + index ] : null;
                        // The shirtSize <select> option value is a JSON-encoded "Majica"
                        // service calc item (see booking/form.blade.php) - it's its own
                        // line item in booking.calc, not a guest attribute.
                        let shirt = guestData['shirtSize' + index ] ? JSON.parse(guestData['shirtSize' + index ]) : null;
                        let schoolClass = guestData['schoolClass' + index ] ? guestData['schoolClass' + index ] : null;
                        let birthDate = birthDateYear + '-' + birthDateMonth + '-' + birthDateDay;

                        // Upit: djeca starija od AGE_LIMIT_YEARS na dan polaska (item.dateFrom,
                        // not a fixed calendar date - it moves with the trip) idu na "Request"
                        // umesto direktne rezervacije.
                        if (birthDateYear && birthDateMonth && birthDateDay) {
                            let birthDateObj = new Date( +birthDateYear, +birthDateMonth - 1, +birthDateDay );
                            if ( isOverAgeLimit( birthDateObj, item.dateFrom ) ) {
                                needsRequest = true;
                            }
                        }

                        note += firstName && lastName ? 'Dete: ' + firstName + ' ' + lastName + '; ' : '';
                        note += teacherName ? 'Nastavnik: ' + teacherName + '; ' : '';
                        note += schoolName ? 'Škola: ' + schoolName + '; ' : '';
                        note += schoolClass ? 'Razred: ' + schoolClass + '; ' : '';
                        note += note ? '/ ' : '';
                        //let note = guestData['note' + g ] ? guestData['note' + g ] : null;

                        let address = formData.address;
                        let email = formData.email;

                        guests[index] = {
                            firstName: firstName,
                            lastName: lastName,
                            birthDate: birthDate,
                            gender: gender,
                            city: city,
                            customerCity: city,
                            address: address,
                            customerAddress: address,
                            phone: phone,
                            email: email
                            //note: note,
                        };

                        if (shirt) shirts.push(shirt);
                    });

                    booking.calc[key].guestsData = guests;

                }
            });

            shirts.forEach(shirt => booking.calc.push(shirt));

            // form.blade.php already renders status/skipAvailability hidden inputs
            // server-side (Unavailable/Request based on unit availability) - only
            // escalate them here, never downgrade an existing Request.
            if (needsRequest) {
                booking.$form.find('[name="status"]').val('Request');
                booking.$form.find('[name="skipAvailability"]').val('true');
            }

            // overrides the native raw phone input's value - hidden inputs
            // below get appended after it, so this (with country code) wins.
            booking.params.phone = phone;
            booking.params.paymentType = booking.$payment.find("[name='paymentType']:checked").val() ? booking.$payment.find("[name='paymentType']:checked").val() : 'bankTransfer';
            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            if (note) {
                booking.params.note = note;
            }

            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calculate($elem) {
            let $row = $elem.parents('.calc-item');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            checked = $elem.attr('data-calc') ? 1 : checked;
            let id = $checkbox.attr('id');
            id = $elem.attr('data-id') ? $elem.attr('data-id') : id;

            let $quantity = $row.find('select.quantity:visible');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }

            $.each(booking.calc, function (key, calc) {

                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);

                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                }
            });


            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        total() {
            booking.totalAmount = 0.00;

            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc) {
                    booking.totalAmount += booking.itemTotal(calc);
                }
            });

            $('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));

            let confirmationPayment = $('[data-confirmationPayment]').attr('data-confirmationpayment') ? $('[data-confirmationPayment]').attr('data-confirmationpayment') : 0;
            const confirmationPercent = $('[data-confirmationPercent]').attr('data-confirmationpercent') ? $('[data-confirmationPercent]').attr('data-confirmationpercent') : null;
            
            const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
            let advance = advancePaymentPercent ? booking.totalAmount * (advancePaymentPercent / 100) : null;

            confirmationPayment = confirmationPercent ? booking.totalAmount * (confirmationPercent / 100) : confirmationPayment;
            if(confirmationPayment) {
                advance = advancePaymentPercent ? (booking.totalAmount - confirmationPayment) * (advancePaymentPercent / 100) : null;
            }

            if(! advance) {
                const advanceConfirmationAmount = $('[data-advanceConfirmationAmount]').attr('data-advanceconfirmationamount');
                advance = advanceConfirmationAmount;
            }

            const rest = (booking.totalAmount - confirmationPayment) - advance;

            let passedConfirmation = $('.advance').attr('data-confirmationpayment');
            if(passedConfirmation) advance = (+advance) + (+passedConfirmation);

            $('.confirmationPayment').html(functions.formatMoney(confirmationPayment, 2, ',', '.'));
            $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));

        }
    }

    booking.init();

});